import { Box, CircularProgress, Container, Typography } from '@mui/material'
import { BackArrow } from 'Assets/SVGs/back-arrow'
import { CAREGIVER_PORTAL_MEMBERS } from 'Pages/Routes'
import { useNavigate, useParams } from 'react-router'
import { useEffect, useState } from 'react'
import { sendGet } from 'hooks/use-fetch'
import { type PortalLocation, type race } from 'core/types'
import { childName } from 'Pages/CaregiverPortal/PortalHelpers'
import { toast } from 'react-toastify'
import { ChildDetails } from 'Pages/CaregiverPortal/Members/ChildDetails'

export interface ChildMemberDetails {
  id: number
  isdid: number
  firstName: string
  lastName: string
  middleName: string
  nickname: string
  suffix: string
  dateOfBirth: Date | null
  birthGender: string | undefined
  races: number[]
  childRaceList: race[]
  tribalAffiliationStatus: boolean | null
  tribalAffiliationID: number | null
  languageID: number | undefined
  primaryLanguage: string
  hasIEP: boolean
  hasIFSP: boolean
  hasEOIS: boolean
  fosterChild: boolean
  hasSNAPBenefits: boolean
  isOnCashAssistance: boolean
  isOnSSI: boolean
  dueDate: Date | null
  unborn: boolean
  primaryLocationID: number | null
  locationIDs: number[]
  location: PortalLocation | null
  newLocation: PortalLocation | null
  canEdit: boolean
  enrollmentCountByService: ServiceEnrollmentCount[] | null
  imageKey: string | null
  hasPendingDuplicate: boolean
}
export interface ServiceEnrollmentCount {
  serviceID: number
  count: number
}

export function ChildDisplay (): JSX.Element {
  const nav = useNavigate()
  const { childId } = useParams()
  const [child, setChild] = useState<ChildMemberDetails | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const getData = async (): Promise<void> => {
      const { response: childRsp, success } = await sendGet(`/CaregiverPortal/GetChildDetails/${childId ?? 0}`, {})
      if (success) {
        setChild(childRsp)
      } else {
        toast.error('Failed to load child details')
      }
      setIsLoading(false)
    }

    void getData()
  }, [childId])

  if (isLoading || child == null) {
    return <CircularProgress />
  } else {
    return <Container sx={{ mb: '24px' }}>
      <Box sx={{ mt: '24px', mb: '24px', display: 'flex' }}>
        <Box onClick={() => { nav(CAREGIVER_PORTAL_MEMBERS) }} sx={{ cursor: 'pointer' }}>
          <BackArrow />
        </Box>
        <Typography variant='h5' sx={{ fontWeight: 600, ml: '5px' }} component='div'>
          {childName(child)}
        </Typography>
      </Box>

      <ChildDetails child={child} />
    </Container>
  }
}
